<template>
    <span>
      <v-row align="center" justify="center">
        <v-col cols="3">
          <v-text-field
            append-icon="mdi-magnify"
            outlined
            solo
            hide-details
            v-model="search"
            class="search"
            placeholder="Search..."
            v-on:keyup.enter="getDataTable()"
            color="#2671D9"
          >
          </v-text-field>
        </v-col>
        <v-col>
          <v-btn
            class="ma-2"
            depressed
            outlined
            color="#2671D9"
            @click="openDialog('filter')"
          >
            <v-icon left color="#2671D9">
              $ic-filter
            </v-icon>
            Filter
          </v-btn>
        </v-col>

      </v-row>

      <!-- column Action -->
      <v-row>
        <v-col class="pt-0">
          <Table :headers="headers" :items="items" @onChangePage="getDataTable" @sortOptions="updateSortDatatable" :defaultSize="5" :loading="isFetching">
            <template slot="action" slot-scope="data">
              <router-link :to="'/user-management/access/edit_access'">
                <v-btn fab x-small color="primary mr-2">
                  <v-icon  class="mdi mdi-square-edit-outline" @click="clickDelete(data.item)"></v-icon>
                </v-btn>
              </router-link>
              <v-btn fab x-small color="primary">
                <v-icon color="#fff" @click="clickDelete(data.item)">mdi-delete</v-icon>
              </v-btn>
            </template>
          </Table>
        </v-col>
      </v-row>
      <v-dialog
        v-model="dialog"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <v-row>
              <v-col>
                <span>{{ dialogTitle }}</span>
              </v-col>
              <v-col class="text-right">
                <v-btn
                  icon
                  x-small
                  @click="dialog = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-container>
              <span v-if="dialogType === 'filter'">
                <v-row>
                  <v-col class="pb-0 pt-1">
                    <div class="label-custom mb-2" :style="'color:' + colorActive">Role</div>
                    <v-autocomplete
                      v-model="filter.role"
                      :items="filterOptions.role"
                      label="Semua Role"
                      dense
                      solo
                      flat
                      outlined
                      item-text="text"
                      item-value="id"
                      return-object
                      cache-items
                      :color="colorActive"
                      clearable
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </span>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              small
              depressed
              color="#999999"
              text
              @click="closeDialog()"
            >
              {{ dialogType === 'filter' ? 'Kembali' : 'Tutup' }}
            </v-btn>
            <v-btn
              v-if="dialogType === 'filter'"
              small
              depressed
              :color="colorActive"
              @click="closeDialog(); getDataTable()"
              dark
            >
              Cari
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </span>
  </template>
<script>
import Table from '../../components/Table.vue'
import alert from '@/commons/helper/alert.helper'
import UserManagementService from '@/services/default/UserManagementService'
import RoleService from '@/services/default/RoleService'
import RefService from '@/services/default/RefService'

const userManagementService = UserManagementService.build()
const roleService = RoleService.build()
const refService = RefService.build()
export default {
  name: 'user-management-user',
  components: {
    Table
  },
  data: () => ({
    colorActive: '#2671D9',
    colorInactive: '#9A9A9A',
    headers: [
      { value: 'number', text: 'No.', sortable: false, align: 'center' },
      { value: 'roleName', text: 'Role', align: 'left', width: '15%' },
      { value: 'Akses', text: 'Akses', align: 'left', width: '65%' },
      { value: 'action', text: 'Aksi', align: 'center' }
    ],
    items: {},
    search: '',
    sortSettings: '',
    isShowPage: true,
    isFetching: false,
    timer: '',
    // dialog
    dialog: false,
    dialogTitle: '',
    dialogType: '',
    filterOptions: {
      company: [],
      branch: [],
      role: []
    },
    filter: {
      role: ''
    },
    // filter: {},
    marker: true,
    active: []
  }),
  async created () {
    // delete localStorage
    // localStorage.removeItem('tableQuery')
    this.getRoleList()
    this.getCompanyList()
  },
  computed: {},
  mounted: function () {
    // this.$nextTick(() => {
    //   // re-get data every 1 minute
    //   this.timer = setInterval(() => {
    //     const tableQuery = JSON.parse(localStorage.getItem('tableQuery'))
    //     if (tableQuery) {
    //       this.getDataTable(tableQuery.page, tableQuery.size)
    //     } else {
    //       this.getDataTable()
    //     }
    //   }, 60000)
    // })
  },
  destroyed: function () {
    // kill re-get data every 1 minute
    clearInterval(this.timer)
  },
  watch: {
    search: function (val) {
      if (val === '') {
        this.getDataTable()
      }
    }
  },
  methods: {
    openDialog (type) {
      this.dialogType = type
      if (type === 'add') {
        // this.dialogTitle = 'Tambah User'
        this.dialogTitle = 'Filter Data'
      }
      this.dialog = true
    },
    closeDialog (type) {
      if (type === 'add') {
        this.filter = {
          role: ''
        }
        this.$refs.observer.reset()
      }

      this.dialog = false
    },
    clickDelete (data) { console.log(data) },

    async resetData () {
      this.items = {}
      // this.search = ''
      this.sortSettings = ''
    },
    async getDataTable (page, size) {
      this.isFetching = true
      this.paging.page = page
      this.paging.size = size

      // let tableQuery = JSON.parse(localStorage.getItem('tableQuery'))

      // localStorage.setItem('tableQuery', JSON.stringify({
      //   page: page,
      //   size: size,
      //   sort_by: tableQuery ? tableQuery.sort_by : ''
      // }))

      // re-get data after set
      // tableQuery = JSON.parse(localStorage.getItem('tableQuery'))

      const param = Object.assign({
        keyword: this.search,
        roleId: this.filter.role ? this.filter.role.id : undefined,
        sort: this.sortSettings ? this.sortSettings : ''
      }, this.paging)

      const response = await userManagementService.getPgb(param)
      if (response.data.success === true) {
        const { data: { data: { content, totalPages, number, size, totalElements } } } = response
        this.items = Object.assign({
          data: content,
          total: totalPages,
          size,
          page: number + 1,
          totalElements
        })
      } else {
        alert.failed(response.data.status + ' - ' + response.data.message)
      }
      this.isFetching = false
    },
    async updateSortDatatable (options) {
      if (options.sortBy) {
        this.sortSettings = ''
        for (let i = 0; i < options.sortBy.length; i++) {
          const sort = options.sortDesc[i] === false ? 'asc' : 'desc'
          let column = ''

          if (options.sortBy[i] === 'role') {
            column = 'role'
          } else if (options.sortBy[i] === 'akses') {
            column = 'akses'
          }

          if (i === 0) {
            this.sortSettings += column + ',' + sort
          } else {
            this.sortSettings += '&sort=' + column + ',' + sort
          }
        }

        // let tableQuery = JSON.parse(localStorage.getItem('tableQuery'))
        // localStorage.setItem('tableQuery', JSON.stringify({
        //   page: tableQuery ? tableQuery.page : 0,
        //   size: tableQuery ? tableQuery.size : 20,
        //   sort_by: this.sortSettings
        // }))
        // tableQuery = JSON.parse(localStorage.getItem('tableQuery'))
        // this.getDataTable(tableQuery.page, tableQuery.size)
        this.getDataTable()
      }
    },
    async getCompanyList () {
      const response = await refService.getCompanyList()
      const { data: { data } } = response
      const temp = data.map(item => {
        return {
          id: item.idCompany,
          text: item.name
        }
      })
      this.filterOptions.company = temp
    },
    async getBranchList () {
      const branch = JSON.parse(localStorage.getItem('branch_list'))?.data
      if (branch) {
        this.filterOptions.branch = branch
      } else {
        const param = {
          companyId: this.input.company.id,
          branchId: ''
        }
        const response = await refService.getBranchList(param)
        const { data: { data } } = response

        const temp = data.map(item => {
          // remap level 1
          item.child = item.child.map(item2 => {
            // remap level 2
            item2.child = item2.child.map(item3 => {
              // remap level 3
              item3.child = item3.child.map(item4 => {
                // remap level 4
                return {
                  id: item4.id,
                  name: item4.name,
                  children: item4.child
                }
              })
              return {
                id: item3.id,
                name: item3.name,
                children: item3.child
              }
            })
            return {
              id: item2.id,
              name: item2.name,
              children: item2.child
            }
          })
          return {
            id: item.id,
            name: item.name,
            children: item.child
          }
        })

        this.filterOptions.branch = temp

        localStorage.setItem('branch_list', JSON.stringify({
          data: temp
        }))
      }
    },
    treeClick (value) {
      const branch = JSON.parse(localStorage.getItem('branch_list'))?.data
      this.input.branch = this.findComplex(branch, value[0])
    },
    async getRoleList () {
      const response = await roleService.getRoleList()
      const { data: { data } } = response
      const temp = data.map(item => {
        return {
          id: item.id,
          text: this.capitalize(item.text)
        }
      })

      this.filterOptions.role = temp
    },
    toggleMarker () {
      this.marker = !this.marker
    },
    exportExcel () {}
  }
}
</script>
  <style scoped>
    .summary-alert-title {
      font-weight: 400;
      font-size: 14px;
      color: #333333;
    }

    .summary-alert-value {
      font-weight: 600;
      font-size: 24px;
      color: #333333;
    }

    .search {
      height: 48px;
    }
  </style>
